import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Grid } from '@mui/material';
import React from 'react';
import ActionIconButton from './ActionIconButton';

const NextPrevComponent = ({
	loading,
	children,
	onPrev,
	onNext
}) => (
	<Grid container>
		<Grid size={12}>
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: 'auto 1fr auto',
				}}
			>
				{typeof onPrev === 'function' && (
					<Box display={'flex'} alignItems={'center'} justifyContent={'center'} marginRight={2}>
						<ActionIconButton
							color="primary"
							size="small"
							variant="contained"
							shape="circle"
							disabled={loading}
							onClick={onPrev}
							aria-label={'previous'}
						>
							<ChevronLeftIcon />
						</ActionIconButton>
					</Box>
				)}
				<Box sx={{ flex: 1 }}>{children}</Box>
				{typeof onNext === 'function' && (
					<Box display={'flex'} alignItems={'center'} justifyContent={'center'} marginLeft={2}>
						<ActionIconButton
							color="primary"
							size="small"
							variant="contained"
							shape="circle"
							disabled={loading}
							onClick={onNext}
							aria-label={'next'}
						>
							<ChevronRightIcon />
						</ActionIconButton>
					</Box>
				)}
			</Box>
		</Grid>
	</Grid>
);

export default NextPrevComponent;
